module.exports = __webpack_public_path__ + "media/images/products/retailers-socialmedia-5-smart-link-8495325c310a36336be1f61bdf5691c9.jpg";